import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { API_GET } from "../../helpers/api";
import * as actions from "../actions/gddk";
import {
  GET_ACTIVE_GDDK_LIST_REQUEST,
  GET_GDDK_HISTORY_LIST_REQUEST,
  GET_GDDK_CONSUMPTION_LIST_REQUEST,
} from "../types";

function* watchGetActiveGDDKList() {
  yield takeEvery(GET_ACTIVE_GDDK_LIST_REQUEST, getActiveGDDKList);
}

function* getActiveGDDKList(action) {
  try {
    const res = yield call(apiGetGDDK, "production-data", {
      ...action.payload,
      gddkStatus: "INITIAL",
    });
    const updatedItems = res.data.items.map((item) => ({
      ...item,
      stationName: item.station.stationName,
    }));
    yield put(actions.getActiveGDDKListSucceeded([...updatedItems]));
  } catch (err) {
    yield put(actions.getActiveGDDKListFailed());
  }
}

function* watchGetGDDKHistoryList() {
  yield takeEvery(GET_GDDK_HISTORY_LIST_REQUEST, getGDDKHistoryList);
}

function* getGDDKHistoryList(action) {
  try {
    const res = yield call(apiGetGDDK, "production-data", {
      ...action.payload,
      gddkStatus: "COMPLETED",
    });

    const updatedItems = res.data.items.map((item) => ({
      ...item,
      stationName: item.station.stationName,
    }));
    const dataList = [...updatedItems];
    yield put(
      actions.getGDDKHistoryListSucceeded({
        dataList,
        total: {
          totalItemCount: res.data.totalItemCount,
          totalPageCount: res.data.totalPageCount,
        },
      })
    );
  } catch (err) {
    yield put(actions.getGDDKHistoryListFailed());
  }
}

function* watchGetGDDKConsumptionList() {
  yield takeEvery(GET_GDDK_CONSUMPTION_LIST_REQUEST, getGDDKConsumptionList);
}

function* getGDDKConsumptionList(action) {
  try {
    const res = yield call(apiGetGDDK, "consumption-data", {
      ...action.payload,
    });
    yield put(actions.getGDDKConsumptionListSucceeded({ ...res.data }));
  } catch (err) {
    yield put(actions.getGDDKConsumptionListFailed());
  }
}

const apiGetGDDK = (url, reqParams) =>
  API_GET(url, {
    ...reqParams,
    gddk: true,
    page: reqParams?.page || 0,
    size: 100,
  });

export default function* gddkSaga() {
  yield all([
    fork(watchGetActiveGDDKList),
    fork(watchGetGDDKHistoryList),
    fork(watchGetGDDKConsumptionList),
  ]);
}
